import { DataSet, DataView } from "vis";
import Timeline from "./components/Timeline.vue";
import Graph2d from "./components/Graph2d.vue";
import Network from "./components/Network.vue";
import "../node_modules/vis/dist/vis.css";

export { Timeline, Graph2d, Network, DataSet, DataView };
